<template>
  <span>
    <svg
      :class="messageBlock ? 'mx-1' : 'mx-4 mt-2'"
      :width="messageBlock ? '15px' : '31px'"
      :height="messageBlock ? '20px' : '39px'"
      viewBox="0 0 31 39"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>D5E459EF-A20E-4EA8-8C32-90AA16784FC1</title>
      <g id="-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="File-Icons-+-Image-Attachment"
          transform="translate(-409.000000, -761.000000)"
        >
          <g id="Group-11" transform="translate(409.000000, 761.000000)">
            <path
              d="M16.8608097,0.9 C17.1934057,0.9 17.645143,1.10094392 17.8700641,1.34762828 L17.8700641,1.34762828 L28.7645244,13.29623 C29.0080514,13.5633206 29.205431,14.0746407 29.205431,14.4344797 L29.205431,14.4344797 L29.205431,35.2501151 C29.205431,35.826911 28.9691743,36.3487572 28.5903979,36.7270546 C28.2099176,37.1070537 27.6852297,37.3430124 27.1087437,37.3430124 L27.1087437,37.3430124 L2.99668728,37.3430124 C2.41737549,37.3430124 1.89282588,37.1087575 1.51335612,36.7287587 C1.13403274,36.3489065 0.9,35.8236601 0.9,35.2421474 L0.9,35.2421474 L0.9,3.00086504 C0.9,2.42053558 1.13508103,1.89512007 1.51627287,1.51500763 C1.89777176,1.13458899 2.42533585,0.9 3.0093865,0.9 L3.0093865,0.9 Z"
              id="Rectangle-4"
              :stroke="messageBlock ? '#13865a' : '#2B3D9A'"
              stroke-width="1.8"
            ></path>
            <text
              id=".MP3"
              font-family="Lato-Black, Lato"
              font-size="8"
              font-weight="700"
              :fill="messageBlock ? '#13865a' : '#2B3D9A'"
            >
              <tspan :x="extension.length > 3 ? '2' : '6'" y="30">
                .{{ extension.toUpperCase() }}
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  name: "FileSVG",
  props: ["extension", "messageBlock"],
};
</script>
